const getUSD = new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" })



export default function getCurrency({ amount, actions, options, defaultReturn }) {
	if (isNaN(amount)) return defaultReturn
	else if (typeof amount !== "number") return defaultReturn
	else if (options?.includes("block-negatives") && amount <= 0) return defaultReturn
	else {
		if (actions.includes("divide")) amount = amount / 100
		if (actions.includes("round")) amount = Math.ceil(amount)

		let currency = getUSD.format(amount)
		if (actions.includes("no-decimal")) currency = currency.slice(0, -3)

		return currency
	}
}
